export default __webpack_public_path__ + "static/media/CarImages.K2500Large.6a635b03.jpg";